import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Label,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import apiResponse from '../../../../services/apiResponse'
import CreateBloc from './Blocs/CreateBloc'
import { accessRole } from "../../../../helpers/access_role"
import CustomSelect from '../../../../helpers/ui/CustomSelect'
import moment from 'moment'
import Shimmer from "react-shimmer-effect";

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear(), years = [];
    startYear = startYear || 1980;  
    while ( startYear <= currentYear + 3 ) {
        var newObj = {};
        var year = startYear++;
        newObj["label"] = year;
        newObj["value"] = year;
        years.push(newObj);
    }   
    return years;
}

const createMonthOptions = () => {
    var months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];

    return months.map(function(month, i) {
        var newObj = {};
        newObj["label"] = month;
        newObj["value"] = ++i;

        return newObj;
    });
}

class IndexView extends Component {

    createBloc = new CreateBloc();
    queryParams = new URLSearchParams(window.location.search)
    userdata = JSON.parse(localStorage.getItem('userdata'));

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            yearOptions: createYearOption(new Date().getFullYear() - 30),
            monthOptions: createMonthOptions(),
            rankOption: [],
            ikuOption: [],
            timeUnitOption: [],
            detail:{},
            emptype:'',
            emptypeOption:[],
            satuanWaktuOption: [
                { label: "Bulan", value: 'Bulan' },
                { label: "Triwulan", value: 'Triwulan' },
                { label: "Semester", value: 'Semester' }
            ],
            jenisSKPOption: [
                { label: "PP No.30 Tahun 2019", value: 1 },
                { label: "PERMENPAN RB No.8 Tahun 2021", value: 2 }
            ],
            skptype:null
        }
    }

    reformatOptions = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
    };

    dateParse = (input) =>{
      let res = "";
      if (input != "" && input != null){
        res = moment(input).format('DD/MM/YYYY')
      }
      return res;
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, '') // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.createBloc.fetchCreateKegiatan(formData)
        // console.log(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    dateParse = (input) =>{
        let res = "";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }
    getEmployeeBirthDetail = (emp) => {
        let res = "";
        if (emp.employee_place_of_birth_city_uuid != null && emp.employee_place_of_birth_city_uuid != '') {
            res = `${emp.employee_place_of_birth_city_name}, ${this.dateParse(emp.employee_date_of_birth)}`;
        } else {
            res = `${emp.employee_place_of_birth_city_text}, ${this.dateParse(emp.employee_date_of_birth)}`;
        }
        return res;
    }
    changeEmptype = (e) => {
        // alert(e.value)
        this.setState({
            emptype : e.value
        })
    }

    componentDidMount() {

        this.createBloc.createKegiatanChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:

                    if (result.data.status){
                        this.setState({
                            loading: false,
                            success: true
                        });
                    } else {
                        this.setState({
                            loading: false,
                            message: result.data.message,
                            failed: true
                        });
                    }

                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.createBloc.employeeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response_employee = result.data.response
                        this.setState({
                            detail: response_employee,
                            emptype : response_employee.employee_type_name.toLowerCase()
                        })
                        // console.log(this.state.emptype.toLowerCase())
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.periodChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let res = result.data.response
                        this.setState({
                            detailPeriod: res,
                            skptype : res.skp_period_type
                        })
                        // console.log(res)
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.createBloc.emptypeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    // console.log(result.data.response.result)
                    this.setState({ 
                        emptypeOption: result.data.response.map(function(data) {
                            var newObj = {};
                            newObj["label"] = data.employee_type_name;
                            newObj["value"] = data.employee_type_name.toLowerCase();
                            
                            return newObj;
                        }), 
                        loadingRank: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        });
        this.createBloc.timeUnitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    // console.log(result.data.response.result)
                    this.setState({ 
                        timeUnitOption: result.data.response.map(function(data) {
                            var newObj = {};
                            newObj["label"] = data.time_unit_name;
                            newObj["value"] = data.time_unit_name;
                            
                            return newObj;
                        }), 
                        loadingRank: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        });

        this.createBloc.ikuChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ 
                        ikuOption: result.data.response.map(function(data) {
                            var newObj = {};
                            newObj["label"] = data.skp_iku_name;
                            newObj["value"] = data.skp_iku_uuid;
                        
                            return newObj;
                          }), 
                        loadingEchelon: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        });
        // console.log(this.userdata.employee_current_work_unit_uuid)
        this.createBloc.fetchRank()
        this.createBloc.fetchEmployee({uuid: this.queryParams.get('euuid') })
        this.createBloc.fetchIku({uuid: this.userdata.employee_current_work_unit_uuid})
        this.createBloc.fetchInitialHeader({employee_uuid: this.queryParams.get('euuid') })
        this.createBloc.fetchEmployeeType()
        this.createBloc.fetchtimeUnit()
        this.createBloc.fetchPeriod({perioduuid: this.queryParams.get('perioduuid') })
    }

    componentWillUnmount(){
        this.createBloc.createChannel.unsubscribe()
        this.createBloc.initialHeaderChannel.unsubscribe()
        this.createBloc.timeUnitChannel.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Tambah Kegiatan SKP</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    {/* <div>
                                        <label>Data Pegawai</label><br />
                                        <Row className="mb-3">
                                            <label className="col-md-2">
                                            NIP
                                            </label>
                                            <Col md="8">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_nip !== "" ? this.state.detail.employee_nip : '-'}</>
                                                    : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-2">
                                            Nama
                                            </label>
                                            <Col md="8">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_full_name !== "" ? this.state.detail.employee_full_name : '-'}</>
                                                    : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-2">
                                            Tempat, Tanggal Lahir
                                            </label>
                                            <Col md="8">
                                                {
                                                    this.state.detail ?
                                                        <>{this.getEmployeeBirthDetail(this.state.detail)}</>
                                                    : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-2">
                                            Jabatan
                                            </label>
                                            <Col md="8">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_current_position_name !== "" ? this.state.detail.employee_current_position_name : '-'}</>
                                                    : <Shimmer><div style={{width: 400, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-2">
                                            Unit Kerja
                                            </label>
                                            <Col md="8">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_current_work_unit_name !== "" ? this.state.detail.employee_current_work_unit_name : '-'}</>
                                                    : <Shimmer><div style={{width: 400, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                    </div>
                                    <hr /><br /> */}
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >   
                                        
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            SKP <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                            
                                            <CustomSelect 
                                                    name="skp_type"
                                                    errorMessage="Pilih SKP"
                                                    options={this.state.jenisSKPOption} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih SKP"
                                                    defaultValue={this.state.skptype}
                                                    // onChange={opt => this.setState({ skptype: opt.value })}
                                                    isDisabled={true}
                                                /> 
                                               
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Tipe Pegawai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                            {/* 
                                            <CustomSelect 
                                                    name="emp_type"
                                                    errorMessage="Pilih Tipe Pegawai"
                                                    options={this.state.emptypeOption} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Tipe Pegawai"
                                                    defaultValue={this.state.emptype}
                                                    onChange={(v) => this.changeEmptype(v)}
                                                /> 
                                                */}
                                                <AvField
                                                    name="emp_type"
                                                    type="text"
                                                    errorMessage="Masukkan Tipe Pegawai"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_activity"
                                                    value={this.state.emptype}
                                                    readonly="readonly"
                                                />
                                            </Col>
                                        </Row>
                                        {
                                            (this.state.skptype ==2)?
                                            <Row className="mb-3">
                                                <label
                                                    htmlFor="no_sk"
                                                    className="col-md-2 col-form-label"
                                                >
                                                Indikator Kinerja Utama <span className="text-danger">*</span>
                                                </label>
                                                <Col md="6">
                                                <CustomSelect 
                                                        name="skp_iku_activity"
                                                        errorMessage="Pilih Tahun"
                                                        options={this.state.ikuOption} 
                                                        validate={{ required: { value: true } }}
                                                        placeholder="Pilih IKU"
                                                        // defaultValue={new Date().getFullYear()}
                                                    />
                                                </Col>
                                            </Row>
                                            : ''
                                        }
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Kegiatan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="skp_activity"
                                                    placeholder="Kegiatan..."
                                                    type="textarea"
                                                    errorMessage="Masukkan Kegiatan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_activity"
                                                    // value={}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                            #Target
                                            </label>
                                        </Row>
                                    { (this.state.emptype == 'fungsional tertentu')?
                                        <>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Target Angka Kredit <span className="text-danger">*</span>
                                            </label>
                                            <Col md="1">
                                                <AvField
                                                    name="skp_target_angka_kredit"
                                                    // placeholder="Target Angka Kredit..."
                                                    type="number"
                                                    errorMessage="Masukkan Target Angka Kredit"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_target_angka_kredit"
                                                    // value={}
                                                />
                                                
                                            </Col>
                                        </Row>
                                        </>
                                        :''
                                    }
                                        <Row className="mb-3">
                                        <AvField
                                            name="skp_created_by"
                                            // placeholder="Target Angka Kredit..."
                                            type="hidden"
                                            id="skp_created_by"
                                            value={this.queryParams.get('euuid')}
                                        />
                                        <AvField
                                            name="skp_period_uuid"
                                            // placeholder="Target Angka Kredit..."
                                            type="hidden"
                                            id="skp_period_uuid"
                                            value={this.queryParams.get('perioduuid')}
                                        />
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Target Kuantitas Output <span className="text-danger">*</span>
                                            </label>
                                            <Col md="1">
                                                <AvField
                                                    name="skp_target_kuantitas"
                                                    // placeholder="Target Kuantitas..."
                                                    type="number"
                                                    errorMessage="Masukkan Target Kuantitas"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_target_kuantitas"
                                                    // value={}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Target Satuan Kuantitas Output <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="skp_target_output"
                                                    // placeholder="Target Output..."
                                                    type="text"
                                                    errorMessage="Masukkan Target Output"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_target_output"
                                                    // value={}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Target Kualitas Mutu <span className="text-danger">*</span>
                                            </label>
                                            <Col md="1">
                                                <AvField
                                                    name="skp_target_kualitas_mutu"
                                                    // placeholder="Target Kualitas Mutu..."
                                                    type="number"
                                                    errorMessage="Masukkan Target Kualitas Mutu"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_target_kualitas_mutu"
                                                    value={100}
                                                    readonly="readonly"
                                                />
                                            </Col>
                                            <Col md="1" style={{marginTop:'10px'}}><b>%</b></Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Target Waktu <span className="text-danger">*</span>
                                            </label>
                                            <Col md="1">
                                                <AvField
                                                    name="skp_target_waktu"
                                                    // placeholder="Target Waktu..."
                                                    type="number"
                                                    errorMessage="Masukkan Target Waktu"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_target_waktu"
                                                    // value={}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Target Satuan Waktu <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                {/* <AvField
                                                    name="skp_target_satuan_waktu"
                                                    placeholder="Target Satuan Waktu..."
                                                    type="nutextmber"
                                                    errorMessage="Masukkan Target Satuan Waktu"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_target_satuan_waktu"
                                                    // value={}
                                                /> */}
                                                <CustomSelect 
                                                    name="skp_target_satuan_waktu"
                                                    errorMessage="Pilih Target Satuan Waktu"
                                                    options={this.state.timeUnitOption} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Target Satuan Waktu"
                                                    // defaultValue={this.state.emptype}
                                                    // onChange={(v) => this.changeEmptype(v)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Target Biaya{/*  <span className="text-danger">*</span> */}
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="skp_target_biaya"
                                                    // placeholder="Target Biaya..."
                                                    type="number"
                                                    errorMessage="Masukkan Target Biaya"
                                                    className="form-control"
                                                    // validate={{ required: { value: true } }}
                                                    id="skp_target_biaya"
                                                    // value={}
                                                />
                                            </Col>
                                        </Row>          

                                        {/* <hr />  

                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                            #Realisasi
                                            </label>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Realisasi Angka Kredit <span className="text-danger">*</span>
                                            </label>
                                            <Col md="1">
                                                <AvField
                                                    name="skp_realisasi_angka_kredit"
                                                    // placeholder="Realisasi Angka Kredit..."
                                                    type="number"
                                                    errorMessage="Masukkan Realisasi Angka Kredit"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_realisasi_angka_kredit"
                                                    // value={}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Realisasi Kuantitas <span className="text-danger">*</span>
                                            </label>
                                            <Col md="1">
                                                <AvField
                                                    name="skp_realisasi_kuantitas"
                                                    // placeholder="Realisasi Kuantitas..."
                                                    type="number"
                                                    errorMessage="Masukkan Realisasi Kuantitas"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_realisasi_kuantitas"
                                                    // value={}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Realisasi Output <span className="text-danger">*</span>
                                            </label>
                                            <Col md="1">
                                                <AvField
                                                    name="skp_realisasi_output"
                                                    // placeholder="Realisasi Output..."
                                                    type="number"
                                                    errorMessage="Masukkan Realisasi Output"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_realisasi_output"
                                                    // value={}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Realisasi Kualitas Mutu <span className="text-danger">*</span>
                                            </label>
                                            <Col md="1">
                                                <AvField
                                                    name="skp_realisasi_kualitas_mutu"
                                                    // placeholder="Realisasi Kualitas Mutu..."
                                                    type="number"
                                                    errorMessage="Masukkan Realisasi Kualitas Mutu"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_realisasi_kualitas_mutu"
                                                    // value={}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Realisasi Waktu <span className="text-danger">*</span>
                                            </label>
                                            <Col md="1">
                                                <AvField
                                                    name="skp_realisasi_waktu"
                                                    // placeholder="Realisasi Waktu..."
                                                    type="number"
                                                    errorMessage="Masukkan Realisasi Waktu"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_realisasi_waktu"
                                                    // value={}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Realisasi Satuan Waktu <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <AvField
                                                    name="skp_realisasi_satuan_waktu"
                                                    placeholder="Realisasi Satuan Waktu..."
                                                    type="nutextmber"
                                                    errorMessage="Masukkan Realisasi Satuan Waktu"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_realisasi_satuan_waktu"
                                                    // value={}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Realisasi Biaya <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <AvField
                                                    name="skp_realisasi_biaya"
                                                    // placeholder="Realisasi Biaya..."
                                                    type="number"
                                                    errorMessage="Masukkan Realisasi Biaya"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_realisasi_biaya"
                                                    // value={}
                                                />
                                            </Col>
                                        </Row> */}

                                        <hr />
                                        
                                        <Row>
                                            <Col md="9">
                                                <Link to={`/kepegawaian/skp.html?data&euuid=${this.queryParams.get('euuid')}`}>
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo={this.state.message ?? "Data gagal disimpan"}

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/skp.html?datakegiatan&euuid=${this.queryParams.get('euuid')}&perioduuid=${this.queryParams.get('perioduuid')}`}/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView